import { makeRESTApiRequests } from "../helpers/api";
import { ENDPOINTS } from "../helpers/constants";

export const timerTrackerService = {
  clockIn: async (reqBody = {}) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.CLOCK_IN,
      requestBody: reqBody,
      method: "POST",
    });

    return { response, error };
  },
  clockOut: async (reqBody = {}) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.CLOCK_OUT,
      requestBody: reqBody,
      method: "POST",
    });

    return { response, error };
  },
  getTimeLogs: async (reqBody = {}, signal) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.GET_TIME_LOGS,
      requestBody: reqBody,
      method: "POST",
      signal,
    });

    return { response, error };
  },
  deleteLog: async (id) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.DELETE_LOG(id),
      method: "DELETE",
    });

    return { response, error };
  },
  addLog: async (log) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.CREATE_LOG,
      method: "POST",
      requestBody: log,
    });

    return { response, error };
  },
  updateLog: async (log) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.UPDATE_LOG(log?._id),
      method: "PUT",
      requestBody: log,
    });

    return { response, error };
  },
  batchUpdate: async (updates) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.UPDATE_MULTIPLE_LOG,
      method: "POST",
      requestBody: updates,
    });

    return { response, error };
  },

  // Call to get data related to finance
  salesFinanceDashboardService: async (updates) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.GET_SALES_FINANCE_DASHBOARD_DATA,
      method: "POST",
      requestBody: updates,
    });

    return { response, error };
  },
  profitAndLossFinanceDashboardService: async (updates) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.GET_PROFIT_AND_LOSS_FINANCE_DASHBOARD_DATA,
      method: "POST",
      requestBody: updates,
    });

    return { response, error };
  },
  cashFlowFinanceDashboardService: async (updates) => {
    const { response, error } = await makeRESTApiRequests({
      endpoint: ENDPOINTS.GET_CASHFLOW_TREND_FINANCE_DASHBOARD_DATA,
      method: "POST",
      requestBody: updates,
    });

    return { response, error };
  },
};
